export default __webpack_public_path__ + "static/media/intro2.b1edd7ff.mp3";